exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "tr.hidden-row{background-color:#f5a9a9}", ""]);

